import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { AuthComponent } from './auth/auth.component';
import { LogoutComponent } from './logout/logout.component';
import { RootComponent } from './root.component';

@NgModule({
    exports: [
        RootComponent,
        AuthComponent,
        LogoutComponent
    ],
    imports: [
        SharedModule,
        BrowserModule,
        RouterModule
    ],
    declarations: [
        RootComponent,
        AuthComponent,
        LogoutComponent
    ]
})
export class RootModule { }
